<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.57147 20C8.2789 20 7.98633 19.888 7.76348 19.6651C7.31663 19.2183 7.31663 18.496 7.76348 18.0492L13.8125 12.0001L7.76348 5.95111C7.31663 5.50426 7.31663 4.78199 7.76348 4.33514C8.21033 3.88829 8.9326 3.88829 9.37945 4.33514L16.2365 11.1922C16.6833 11.639 16.6833 12.3613 16.2365 12.8081L9.37945 19.6651C9.1566 19.888 8.86403 20 8.57147 20Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
